const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
// External dealer file host. Override with REACT_APP_EXTERNAL_FILE_BASE_URL if it ever changes.
const EXTERNAL_FILE_BASE_URL =
  process.env.REACT_APP_EXTERNAL_FILE_BASE_URL || 'https://backend-production-50c05.up.railway.app/api/files/';

/**
 * Resolves an image URL for display.
 * - Relative paths starting with /api/ are prefixed with BACKEND_URL
 * - External storage paths in the form storage:bucket/path are mapped to the external file API
 * - Absolute URLs (http/https) are returned as-is
 * - Empty/null values return empty string
 */
export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('/api/')) return BACKEND_URL ? `${BACKEND_URL}${url}` : url;
  if (url.startsWith('storage:')) return `${EXTERNAL_FILE_BASE_URL}${url.replace('storage:', '').replace(/^\/+/, '')}`;
  return url;
};
